import React from 'react';
import PropTypes from 'prop-types';

import { withError } from '../shared/components/error-boundary';
import { Helpers } from '../core/src/helpers';
import withWindowResize from '../ui/components/window-resize';
import withPrices from '../product/components/product-price/with-product-price';
import { withAddToCart } from '../product/components/purchase-button-container';

import './hero-banner.less';

class HeroBanner extends React.PureComponent {
    state = {
        expanded: false,
    };

    constructor(props) {
        super(props);
        this.customHtmlRef = React.createRef();
    }

    static propTypes = {
        /* comma delimited list of height by device type ( desktop, tablet, mobile ) */
        maxHeight: PropTypes.string
    }

    toggleBanner = () => {
        this.setState({ expanded: !this.state.expanded });
    };

    componentDidUpdate() {
        const { prices } = this.props
        /** Replace well defined price element */
        if (this.props.customHtml && this.customHtmlRef && Object.keys(prices || {}).length > 0) {
            const priceElements = this.customHtmlRef.current.querySelectorAll('[data-price]') || [];
            for (let index = 0; index < priceElements.length; index++) {
                const elem = priceElements[index];
                const { dataset = {} } = elem;
                const { price: sku, pricemod, pricemodtype, nostrike } = dataset;
                const skus = sku.split(",");
                const prdPrice = skus.length > 1 ?
                    skus.reduce((rPrice, s) => {
                        let cPrice = prices[s];
                        if (cPrice) {
                            if (!rPrice) {
                                rPrice = { ...cPrice };
                            } else {
                                //sum up any additional product prices
                                rPrice.regularPrice += cPrice.regularPrice;
                                rPrice.salePrice += cPrice.salePrice;
                            }
                        }
                        return rPrice;
                    }, null)
                    : prices[sku];

                if (prdPrice) {
                    if (pricemod) {
                        try {
                            prdPrice.salePrice = pricemodtype === '%' ? prdPrice.salePrice * (pricemod / 100) : prdPrice.salePrice + (pricemod * 1);
                        } catch (e) {
                            console.log('error', e);
                        }
                    }
                    const [regPrice, regDec] = Helpers.formatCurrency(prdPrice.regularPrice, '', true).split('.');
                    const [numeralPrice, decimalPrice] = Helpers.formatCurrency(prdPrice.salePrice, '', true).split('.');
                    let strikeThroughPrice = prdPrice.regularPrice > prdPrice.salePrice && !nostrike ? `
                    <span class="strike-price">
                        <span class='currency-symbol'>$</span>
                        <span>${regPrice}.<span class='cent-amount'>${regDec}</span></span>
                    </span>` : ''

                    elem.outerHTML =
                        `<div class="prd-price">
                            <span class="list-price">
                                ${strikeThroughPrice}
                            </span>
                            <span class="sale-price ">
                                <span class='currency-symbol'>$</span>
                                <span>${numeralPrice}.<span class='cent-amount'>${decimalPrice}</span></span>
                            </span>
                        </div>`
                }
            }
        }
    }

    onBannerClick = (e) => {
        const { productsList, addMultipleToCart, launchCartFlyout, onClick } = this.props;
        const { target = {} } = e;
        const { addtocart } = (target.dataset || {});

        if (addtocart) {
            const skusToAdd = addtocart.split(',');
            //if product exists in product group add to cart, for now exclude CTO products from action
            const targetProducts = productsList && productsList.filter(p => skusToAdd.indexOf(p.sku) > -1 && p.prdClass !== 'CTO');
            targetProducts && addMultipleToCart(targetProducts, 1, false).then(launchCartFlyout);
        }
        typeof onClick === 'function' && onClick(e);
    }

    render() {
        const { maxHeight, banner, device } = this.props;
        let customStyles = {};
        let align = 'hero-banner-' + (this.props.align || 'left');
        let customClass = align + ' hero-banner ' + (this.props.className || '');
        let contentStyle = {};

        if (!!banner) {
            // if dlpBanner
            if (banner.key === 'dlpBanner' && banner.bannerImage) {
                let { bannerImage = {} } = banner;
                let { url: dlpBannerImageUrl } = bannerImage;

                Object.assign(customStyles, {
                    backgroundImage: `url(${dlpBannerImageUrl})`,
                });
                customClass += ' dlp-banner';
            } else {
                // default
                Object.assign(customStyles, {
                    backgroundImage: 'url(' + this.props.banner.backgroundImage + ')',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                });
            }
        }

        if (maxHeight && !this.state.expanded) {
            const [desktopHeight, tabletHeight, mobileHeight] = maxHeight.split(",");
            const bannerHeight = device == 'desktop' ? desktopHeight :
                device == 'tablet' && tabletHeight ? tabletHeight :
                    device == 'mobile' && mobileHeight ? mobileHeight : desktopHeight;
            contentStyle.height = `${bannerHeight}px`;
            contentStyle.overflow = 'hidden';
        }

        if (this.props.customHtml) {
            return (
                <div className={customClass} style={customStyles}
                    onClick={this.onBannerClick} >
                    <div style={contentStyle}
                        ref={this.customHtmlRef}
                        dangerouslySetInnerHTML={Helpers.createMarkup(this.props.customHtml)} />
                    {maxHeight && <div
                        onClick={this.toggleBanner}
                        className={`banner-toggle hp-icon ${this.state.expanded ? ' page-up' : ' page-down'}`}
                    />}
                </div>
            );
        }

        return (
            <div className={customClass} style={customStyles}>
                {this.props.children}
            </div>
        );
    }
}

export default withError(withWindowResize(withPrices(withAddToCart(HeroBanner))));
